var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9999 11.1319L24 14.3406C22.3643 14.3406 20.8487 13.8082 19.6116 12.9048V19.4265C19.6116 22.6835 17.0071 25.3333 13.8057 25.3333C12.5686 25.3333 11.4215 24.9364 10.4785 24.2627L10.4769 24.261C8.98059 23.1915 8 21.4236 8 19.4258C8 16.1689 10.6044 13.519 13.8059 13.519C14.0715 13.519 14.3319 13.5413 14.5882 13.5766L14.5881 16.8534C14.3404 16.7746 14.0787 16.7287 13.8057 16.7287C12.3437 16.7287 11.1542 17.939 11.1542 19.4265C11.1542 20.4623 11.7319 21.3623 12.5758 21.8141C12.9438 22.0111 13.3618 22.1241 13.8056 22.1241C15.2339 22.1241 16.399 20.9682 16.4521 19.528L16.4571 6.66663H19.6115C19.6115 9.19299 21.6514 11.1319 23.9999 11.1319Z",
    fill: "#151419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokChart);
export default __webpack_public_path__ + "static/media/tiktok-chart.b8b7ea0b0989f0c3ecddfe02ce6be1b4.svg";
export { ForwardRef as ReactComponent };